<script setup lang="ts" name="SupportButton">
import { type RouteLocationNamedRaw, RouterLink } from 'vue-router';

import Icon from '~/components/Icon.vue';

const { to } = defineProps<{
  to: RouteLocationNamedRaw;
}>();
</script>

<template>
  <RouterLink
    :to="to"
    data-test="support-link"
    class="ml-auto flex h-full items-center justify-center px-6 hover:bg-charcoal-1 lg:ml-0 xl:space-x-2"
  >
    <Icon icon="mdi:lifebuoy" class="text-primary-8" />
    <span
      class="hidden text-body-2 capitalize text-primary-8 hover:text-primary-6 focus-visible:text-primary-8 xl:block"
    >
      Support
    </span>
  </RouterLink>
</template>
